<template>
  <v-row no-gutters class="pt-5 pr-2">
    <v-col v-if="isFetched">
      <card-title-row translation-path="navbar.zdm_failures" />
      <sidebar-row class="pt-4">
        <v-col cols="9" class="pa-0">
          <v-text-field
            id="searchField"
            outlined
            dense
            :hint="$i18n.t('sidebar.failuresSearch')"
            persistent-hint
            clearable
            type="number"
            v-model="search"
            @keydown.enter="findData"
            class="align-center justify-center"
          >
            <template #append>
              <v-icon :color="'rgba(0,0,0,0.7)'" size="24" @click="findData">
                mdi-magnify
              </v-icon>
            </template>
          </v-text-field>
        </v-col>
      </sidebar-row>
      <main-loader v-if="isSearching"></main-loader>
      <sidebar-row v-else class="pr-3">
        <v-list>
          <v-list-item
            v-for="item in computedData"
            :key="item.id"
            @click="openFailure(item.failure_id)"
            :ripple="false"
            class="pa-0 mb-5 folders-list"
          >
            <v-list-item-content class="ma-0 pa-0">
              <sidebar-row :has-icon-column="false">
                <failure-preview :item="item" class="folder-element"></failure-preview>
              </sidebar-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </sidebar-row>
    </v-col>
    <v-col v-else>
      <main-loader />
    </v-col>
  </v-row>
</template>

<script>
import CardTitleRow from '@/components/CardTitleRow';
import MainLoader from '@/components/MainLoader';
import { call, get } from 'vuex-pathify';
import SidebarRow from '@/components/SidebarRow';
import FailurePreview from '@/components/FailurePreview';
export default {
  name: 'ZDMFailures',
  components: { FailurePreview, MainLoader, CardTitleRow, SidebarRow },
  data: () => ({
    search: null,
    isFetched: false,
    isSearching: false,
    foundFailures: [],
  }),
  computed: {
    failures: get('zdmFailures/failures'),
    computedData() {
      if (this.foundFailures.length > 0) {
        return this.foundFailures.map(item => {
          return {
            ...item,
            titleText: this.getTitleText(item),
          };
        });
      } else {
        return [];
      }
    },
  },
  methods: {
    findFailures: call('zdmFailures/findFailures'),
    getFailures: call('zdmFailures/getFailures'),
    async findData() {
      this.isSearching = true;
      let result;
      try {
        result = await this.findFailures(this.search);
        this.foundFailures = result;
      } catch (e) {
        console.log(e);
        this.foundFailures = [];
      } finally {
        this.isSearching = false;
      }

      if (this.foundFailures.length === 0) {
        this.$store.set('snackbar/PUSH_MESSAGE!', {
          message: this.$i18n.t('snackbar.failuresNotFound', { name: this.search }),
        });
        this.search = null;
      }
    },
    async openFailure(id) {
      await this.$router.push({
        name: 'zdm_failure',
        params: { fid: id },
      });
      this.foundFailures = [];
    },
    getTitleText(item) {
      return this.$i18n.t('dialog.zdmFailuresCardTitle', { id: item.failure_number });
    },
    async init() {
      await Promise.all([this.getFailures()]);
      this.isFetched = true;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.folder-element:hover {
  background-color: rgba(188, 188, 188, 0.2);
}
.folders-list {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 0px rgba(0, 0, 0, 0.15) !important;
}
</style>
